var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var JobContent = function(el) {
    var t = this;
    t.$el = $( el );
    t.$picker = t.$el.prev( '.nav-job-picker' );
    t.$headerBar = $( '.header-bar' );

    if ( t.$picker.length ) {
        $('.header .local-nav').empty().append(this.$picker);

        $(window).add('main').on('scroll', function(event) {
            var infoTop = this.$el.offset().top - t.$headerBar.outerHeight();
            var scrollTop = $(event.target).scrollTop();

            $('body').toggleClass('local-nav-visible', infoTop < scrollTop);
        }.bind(this));

        this.$picker.on('change', 'select', function(event) {
            var id = event.target.value,
                url = $(event.target).children("option:selected").data( "href" );

            window.location.href = url;
        }.bind(this));

        this.$picker.on('click', '.nav-job-picker__button', function(event) {
            var $target = $( event.target );

            if ( $target.attr( 'href' ).indexOf('#') !== 0 ) {
                return true;
            }

            event.preventDefault();

            var offset = $( $target.attr( 'href' ) ).offset().top - t.$headerBar.outerHeight();

            $('html, body').animate({
                scrollTop: offset
            }, 600);
        }.bind(this));
    }
};

module.exports = JobContent;
